import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { signup } from 'slice/userSlice';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import Button from 'components/Button';

const Add = () => {
    const [formData, setFormData] = useState({
        name: '',
        username: '',
        password: ''
    });
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { loading, response, error, message } = useSelector((state) => state.user);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!formData.name || !formData.username || !formData.password) {
            toast.warn("Please fill all fields");
            return;
        }
        dispatch(signup(formData));
    };

    useEffect(() => {
        if (response && response.status === 201) {
            toast.success("Admin created successfully");
            navigate('/khajuraho/admins');
        } else if (error) {
            toast.error(message || "Failed to create admin");
        }
    }, [response, error, navigate, message]);

    return (
        <div className="container-fluid mt-5">
            <div className="mainheadig mx-4">
                <h4 className="text-white font-weight-bold">Add New Administrator</h4>
            </div>
            <div className="row justify-content-center mt-4">
                <div className="col-md-6">
                    <div className="card shadow-sm" style={{ borderRadius: '15px' }}>
                        <div className="card-body p-4">
                            <form onSubmit={handleSubmit}>
                                <div className="form-group mb-3">
                                    <label htmlFor="nameInput" className="font-weight-bold">Full Name</label>
                                    <input 
                                        id="nameInput"
                                        type="text" 
                                        name="name" 
                                        className="form-control" 
                                        placeholder="Enter full name"
                                        onChange={handleChange}
                                        value={formData.name}
                                    />
                                </div>
                                <div className="form-group mb-3">
                                    <label htmlFor="usernameInput" className="font-weight-bold">Username</label>
                                    <input 
                                        id="usernameInput"
                                        type="text" 
                                        name="username" 
                                        className="form-control" 
                                        placeholder="Enter username"
                                        onChange={handleChange}
                                        value={formData.username}
                                    />
                                </div>
                                <div className="form-group mb-4">
                                    <label htmlFor="passwordInput" className="font-weight-bold">Password</label>
                                    <input 
                                        id="passwordInput"
                                        type="password" 
                                        name="password" 
                                        className="form-control" 
                                        placeholder="Enter password"
                                        onChange={handleChange}
                                        value={formData.password}
                                    />
                                </div>
                                <Button 
                                    type="submit" 
                                    text={loading ? "Creating..." : "Create Admin"} 
                                    disabled={loading}
                                    className="btn addbtn btn-block py-2"
                                />
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Add;
